// Container.js with styled-components

import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import SectionNavigation from "@components/SectionNavigation/SectionNavigation";
import DosingCalculator from '@components/Calculator/DosingCalculator';
import ProcedureType from '@components/ProcedureType/ProcedureType';
import Tabs from "@components/Tabs";
import Accordion from "@components/Accordion";
import Events from "@components/Events/events";
import Carousel from "@components/Carousel/Carousel";
import EntryModal from '@components/Modal/EntryModal';
import InfoIcon from "@images/icons/info-icon.svg";


const getContainerStyle = (id) => {
	if (id === 'compare-the-cost') {
		return css`
		background-color: #F5F5F5;
	`;
	}
}

// Create styled components for the Container
const StyledContainer = styled.div.attrs({
	className: 'parent-wrapper'
})`
  /* Base styles */
  background-color: ${props => props.$backgroundColor || 'transparent'};
  box-shadow: ${props => props.$boxShadow || 'none'};

  /* Apply custom style based on contentfulid */
  ${props => (props.$contentfulid?.trim() !== '' && props.$contentfulid !== null && props.$contentfulid !== undefined) ? getContainerStyle(props.$contentfulid) : ''}

  /* Desktop spacing */
  ${props => props.$paddingTopDesktop && props.$paddingTopDesktop !== null && props.$paddingTopDesktop !== undefined && `padding-top: ${props.$paddingTopDesktop}px !important;`}
  ${props => props.$paddingBottomDesktop && props.$paddingBottomDesktop !== null && props.$paddingBottomDesktop !== undefined && `padding-bottom: ${props.$paddingBottomDesktop}px !important;`}
  ${props => props.$marginTopDesktop && props.$marginTopDesktop !== null && props.$marginTopDesktop !== undefined && `margin-top: ${props.$marginTopDesktop}px !important;`}
  ${props => props.$marginBottomDesktop && props.$marginBottomDesktop !== null && props.$marginBottomDesktop !== undefined && `margin-bottom: ${props.$marginBottomDesktop}px !important;`}
  ${props => props.$paddingLeftDesktop && props.$paddingLeftDesktop !== null && props.$paddingLeftDesktop !== undefined && `padding-left: ${props.$paddingLeftDesktop}px !important;`}
  ${props => props.$paddingRightDesktop && props.$paddingRightDesktop !== null && props.$paddingRightDesktop !== undefined && `padding-right: ${props.$paddingRightDesktop}px !important;`}
  ${props => props.$marginLeftDesktop && props.$marginLeftDesktop !== null && props.$marginLeftDesktop !== undefined && `margin-left: ${props.$marginLeftDesktop}px;`}
  ${props => props.$marginRightDesktop && props.$marginRightDesktop !== null && props.$marginRightDesktop !== undefined && `margin-right: ${props.$marginRightDesktop}px;`}
  ${props => props.$maxWidthDesktop && props.$maxWidthDesktop !== null && props.$maxWidthDesktop !== undefined && `max-width: ${props.$maxWidthDesktop}px !important;`}

  /* Background image for desktop */
  ${props => props.$backgroundImage && css`
    background-image: url(${props.$backgroundImage});
    background-size: cover;
    background-position: center;
  `}

  /* Mobile spacing and background image */
  @media (max-width: 1023px) {
    /* Mobile spacing (with fallbacks to desktop) */
${props => (props.$paddingTopMobile !== undefined && props.$paddingTopMobile !== null || props.$paddingTopDesktop !== undefined) &&
		`padding-top: ${props.$paddingTopMobile !== undefined && props.$paddingTopMobile !== null ? props.$paddingTopMobile : props.$paddingTopDesktop}px !important;`}
    ${props => (props.$paddingBottomMobile !== undefined && props.$paddingBottomMobile !== null || props.$paddingBottomDesktop !== undefined) &&
		`padding-bottom: ${props.$paddingBottomMobile !== undefined && props.$paddingBottomMobile !== null ? props.$paddingBottomMobile : props.$paddingBottomDesktop}px !important;`}
    ${props => (props.$marginTopMobile !== undefined && props.$marginTopMobile !== null || props.$marginTopDesktop !== undefined) &&
		`margin-top: ${props.$marginTopMobile !== undefined && props.$marginTopMobile !== null ? props.$marginTopMobile : props.$marginTopDesktop}px !important;`}
    ${props => (props.$marginBottomMobile !== undefined && props.$marginBottomMobile !== null || props.$marginBottomDesktop !== undefined) &&
		`margin-bottom: ${props.$marginBottomMobile !== undefined && props.$marginBottomMobile !== null ? props.$marginBottomMobile : props.$marginBottomDesktop}px !important;`}
    ${props => (props.$paddingLeftMobile !== undefined && props.$paddingLeftMobile !== null || props.$paddingLeftDesktop !== undefined) &&
		`padding-left: ${props.$paddingLeftMobile !== undefined && props.$paddingLeftMobile !== null ? props.$paddingLeftMobile : props.$paddingLeftDesktop}px !important;`}
    ${props => (props.$paddingRightMobile !== undefined && props.$paddingRightMobile !== null || props.$paddingRightDesktop !== undefined) &&
		`padding-right: ${props.$paddingRightMobile !== undefined && props.$paddingRightMobile !== null ? props.$paddingRightMobile : props.$paddingRightDesktop}px !important;`}
    ${props => (props.$marginLeftMobile !== undefined && props.$marginLeftMobile !== null || props.$marginLeftDesktop !== undefined) &&
		`margin-left: ${props.$marginLeftMobile !== undefined && props.$marginLeftMobile !== null ? props.$marginLeftMobile : props.$marginLeftDesktop}px;`}
    ${props => (props.$marginRightMobile !== undefined && props.$marginRightMobile !== null || props.$marginRightDesktop !== undefined) &&
		`margin-right: ${props.$marginRightMobile !== undefined && props.$marginRightMobile !== null ? props.$marginRightMobile : props.$marginRightDesktop}px;`}
    ${props => (props.$maxWidthMobile !== undefined && props.$maxWidthMobile !== null || props.$maxWidthDesktop !== undefined) &&
		`max-width: ${props.$maxWidthMobile !== undefined && props.$maxWidthMobile !== null ? props.$maxWidthMobile : props.$maxWidthDesktop}px !important;`}

    /* Mobile background image (overrides desktop) */
    ${props => props.$backgroundImageMobile && css`
      background-image: url(${props.$backgroundImageMobile});
      background-size: cover;
      background-position: center;
    `}
  }

  &.why-exparel--2-cards {
      display: flex;
      flex-direction: column;
      padding-left: 24px;
      padding-right: 24px;

      @media (min-width: 768px) {
        flex-direction: row;
      }
  }

  &.why-exparel--bottles {
      &.why-exparel--bottles-1 {
        min-height: 342px;
        position: relative;

        > picture {
          width: 80px;
          height: 80px;
          position: absolute;
          bottom: calc(-80px / 2);
          left: calc(100% / 2 - 80px / 2);
          z-index: 10;

          img {
            width: 100%;
            height: 100%;
          }

          @media (min-width: 768px) {
            left: initial;
            right: calc(-80px/2 - 32px/2);
            bottom: calc(100%/2 - 80px/2);
          }
        }

        > div {
          row-gap: 16px;
        }

        @media (min-width: 768px) {
          min-height: 372px;
        }
      }

      &.why-exparel--bottles-2 {
        min-height: 460px;

        > div {
          min-height: 460px;
        }

        @media (min-width: 768px) {
          min-height: 372px;

          > div {
            min-height: 372px;
          }
        }
      }

      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
  }

  &.container--why-exparel-table {
    margin-left: 24px;
    margin-right: 24px;

    @media (min-width: 1025px) {
      margin-left: auto;
      margin-right: auto;
    }

    .banner-container--img {
      position: absolute;
      bottom: -2rem;
      right: -4rem;
      transform: none;
      margin: 0;
      top: initial;
    }
  }

  &[id='sitemap'] {
    hr {
      border-color: #F49F65;
      margin: 48px auto;
    }
      
    [data-component="text-component"]:not(:first-of-type):before{
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      border-top: 2px solid #F49F65;
      border-right: 2px solid #F49F65;
      transform: rotate(135deg);
      position: absolute;
      top: -45px;
    }
    [data-component="text-component"] {
      margin-bottom: 80px;
      position: relative;
      h4 {
        margin-bottom: 24px;
        color: #7ac593;
      }
      h5 {
        margin: 24px 0;
      }
      
    }
  }
`;

// Container variants
const DefaultContainer = styled(StyledContainer)`
  &.container-default {}
`;

const QuoteContainer = styled(StyledContainer)`
  &.container-quote {}
`;

const TabsContainer = styled(StyledContainer)`
  &.container-tabs {
  }
`;

const AccordionContainer = styled(StyledContainer)`
  &.container-accordion {
  }
`;

const ProcedureTypeContainer = styled(StyledContainer)`
  &.container-procedure-type {
  }
`;

const CarouselContainer = styled(StyledContainer)`
  &.container-carousel {
  }
`;

const OverflowScrollMobile = styled(StyledContainer)`
  &.container-overflow-scroll-mobile {
    ${props => props.$maxWidthDesktop && props.$maxWidthDesktop !== null && `width: ${props.$maxWidthDesktop}px !important;`}
		@media (max-width: 1023px) {
    picture {
      overflow-x: scroll;
      img {
      overflow: hidden;
      max-width: 1440px;
      }
    }
    }

    [data-component="text-component"] {
      display: block;
      position: relative;
      margin: auto;
      text-align: center;
      &> * {
        display: inline-flex;
        gap: 5px;
        align-items: center;
        &::before {
          content: '';
          background-image: url(${InfoIcon});
          background-size: 25px 24px;
          background-position: center;
          background-repeat: no-repeat;
          width: 25px;
          height: 24px;
          position: relative;
          top: 0;
          left: 0;
        }
      }
      @media (min-width: 1024px) {
        display: none;
      }
    }
`;

// const SectionNavContainer = styled(SectionNavigationContainer);

const FlexContainer = styled(StyledContainer)`
  &.container-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;

    /* Add these styles to make images maintain actual size */
    & > picture {
      flex: 0 0 auto; /* Don't grow or shrink, keep actual size */
      max-width: max-content;
    }

    & > .Text__StyledTextContainer-cArlYP {
      flex: 1; /* Allow text container to take remaining space */
    }
  }
`;

const GridColoumnContainer = styled(StyledContainer)`
  &.container-grid-coloumn {
  }
`;
// Container component definition
const Container = ({
	children,
	className = '',
	type = 'Default',
	maxWidth = 'DEFAULT',
	backgroundColor,
	backgroundImage,
	backgroundImageMobile,
	paddingTopDesktop,
	paddingBottomDesktop,
	marginTopDesktop,
	marginBottomDesktop,
	paddingLeftDesktop,
	paddingRightDesktop,
	marginLeftDesktop,
	marginRightDesktop,
	paddingTopMobile,
	paddingBottomMobile,
	marginTopMobile,
	marginBottomMobile,
	paddingLeftMobile,
	paddingRightMobile,
	marginLeftMobile,
	marginRightMobile,
	maxWidthDesktop,
	maxWidthMobile,
	entryTitle,
	classOverlay,
	borderRadius,
	borderRadiusTop,
	borderRadiusBottom,
	contentfulid,
	items,
  visibility,
  boxShadow,
  ...otherProps
}) => {
  // Container class names
  const containerClasses = {
	  Default: `max-w-default mx-auto px-[24px] lg:px-[35px] xl:px-0 lg:max-w-lg xl:max-w-default ${visibility === 'Top' ? 'z-[1] relative' : ''}`,
	  Quote: "mx-auto ",
	  Carousel: "container-carousel mx-auto px-0 overflow-hidden",
	  Tabs: "container-tabs mx-auto",
    Accordion: "container-accordion mx-auto",
	  "Section Navigation": "container-section-navigation mx-auto px-0 sticky top-0 z-30 bg-white",
	  Flex: "container-flex mx-auto px-0 flex relative",
    "Grid Column": `mx-auto flex flex-col [&>div]:flex-1 gap-[20px] px-[35px]  xl:px-0 lg:flex-row lg:max-w-lg xl:max-w-default ${visibility === 'Top' ? 'z-[1] relative' : ''}`,
    "Default Wide": `w-full relative ${visibility === 'Top' ? 'z-[1]' : ''}`,
    "Dosing Calculator": "container-dosing-calculator mx-auto px-[150px]",
	  "Procedure Type": "container-procedure-type mx-auto",
	  "Overflow Scroll Mobile": `container-overflow-scroll-mobile mx-auto ${visibility === 'Top' ? 'z-[1]' : ''}`
  };

  // Get background image URL
	const backgroundImageUrl = backgroundImage?.file?.url || null;
	const backgroundImageMobileUrl = backgroundImageMobile?.file?.url || null;

  // Filter out styling props from DOM
  const { ...domProps } = otherProps;

  // Styling props for styled-components
  const styleProps = {
    $containerType: type,
    $entryTitle: entryTitle,
    $backgroundColor: backgroundColor,
    $maxWidth: maxWidth,
    $backgroundImage: backgroundImageUrl,
    $paddingTopDesktop: paddingTopDesktop,
    $paddingBottomDesktop: paddingBottomDesktop,
    $marginTopDesktop: marginTopDesktop,
    $marginBottomDesktop: marginBottomDesktop,
    $paddingLeftDesktop: paddingLeftDesktop,
    $paddingRightDesktop: paddingRightDesktop,
    $marginLeftDesktop: marginLeftDesktop,
    $marginRightDesktop: marginRightDesktop,
    $paddingTopMobile: paddingTopMobile,
    $paddingBottomMobile: paddingBottomMobile,
    $marginTopMobile: marginTopMobile,
    $marginBottomMobile: marginBottomMobile,
    $paddingLeftMobile: paddingLeftMobile,
    $paddingRightMobile: paddingRightMobile,
    $marginLeftMobile: marginLeftMobile,
    $marginRightMobile: marginRightMobile,
    $maxWidthDesktop: maxWidthDesktop,
	  $maxWidthMobile: maxWidthMobile,
    $backgroundImageMobile: backgroundImageMobileUrl,
	  $boxShadow: boxShadow,
	  $contentfulid: contentfulid,
  };

  // Combined className for the container
	const containerClassName = `${containerClasses[type]}${className || ''} ${classOverlay ? classOverlay : ''}${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`;

  // Render appropriate container based on type
  switch (type) {
    case 'Quote':
      return (
        <QuoteContainer {...styleProps} className={containerClassName} {...domProps}>
          {children}
        </QuoteContainer>
      );

    case 'Tabs':
      return (
        <TabsContainer {...styleProps} className={containerClassName} {...domProps}>
			  <Tabs items={items} />
        </TabsContainer>
      );

      case 'Accordion':
        return (
          <AccordionContainer {...styleProps} className={containerClassName} {...domProps}>
            <Accordion items={items} />
          </AccordionContainer>
        );

    case 'Section Navigation':
      return (
        <div className="lg:-mt-[1.6rem] lg:h-[56px] relative z-[30]">
            <SectionNavigation {...styleProps} className={containerClassName} {...domProps} sections={items}>
            </SectionNavigation>
        </div>
      );

    case 'Dosing Calculator':
      return (
        <DosingCalculator>
        </DosingCalculator>
      );

    case 'Procedure Type':
      return (
        <ProcedureTypeContainer className={containerClassName}>
          <ProcedureType className={containerClassName} items={items}>
          </ProcedureType>
        </ProcedureTypeContainer>
      );

    case 'Flex':
      return (
        <FlexContainer {...styleProps} className={containerClassName} {...domProps}>
          {children}
        </FlexContainer>
	  );

	  case 'Grid Column':
		  return (
			  <GridColoumnContainer {...styleProps} className={containerClassName} {...domProps}>
				  {children}
			  </GridColoumnContainer>
		  );

    case 'Events Calendar':
      return (
        <Events>
          {children}
        </Events>
      );

    case 'Carousel':
      return (
        <CarouselContainer {...styleProps} className={containerClassName} {...domProps}>
          <Carousel items={items} theme={contentfulid}/>
        </CarouselContainer>
      );

	  case 'Overflow Scroll Mobile':
		  return (
			  <OverflowScrollMobile {...styleProps} className={containerClassName} {...domProps}>
				  {children}
			  </OverflowScrollMobile>
		  );

	  case 'Modal':
		  if (entryTitle?.includes('Welcome Modal')) {
			  return (
				  <EntryModal>
					  {children}
				  </EntryModal>
			  );
		  }
		  return null;

    case 'Default':
    default:
      return (
		  <DefaultContainer {...styleProps} className={containerClassName} {...domProps} id={contentfulid}>
          {children}
        </DefaultContainer>
      );
  }
};

// PropTypes
Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
	type: PropTypes.oneOf(['Default', 'Quote', 'Carousel', 'Tabs', 'Section Navigation', 'Flex', 'Grid Column 3', 'Grid Column', 'Default Wide', 'Dosing Calculator', 'Procedure Type']),
  maxWidth: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
	backgroundImageMobile: PropTypes.shape({
		file: PropTypes.shape({
			url: PropTypes.string,
		}),
	}),
  entryTitle: PropTypes.string,
	marginTopDesktop: PropTypes.number,
	marginBottomDesktop: PropTypes.number,
	marginTopMobile: PropTypes.number,
	marginBottomMobile: PropTypes.number,
	paddingTopDesktop: PropTypes.number,
	paddingBottomDesktop: PropTypes.number,
	paddingTopMobile: PropTypes.number,
	paddingBottomMobile: PropTypes.number,
	paddingLeftDesktop: PropTypes.number,
	paddingRightDesktop: PropTypes.number,
	paddingLeftMobile: PropTypes.number,
	paddingRightMobile: PropTypes.number,
	marginLeftDesktop: PropTypes.number,
	marginRightDesktop: PropTypes.number,
	marginLeftMobile: PropTypes.number,
	marginRightMobile: PropTypes.number,
	maxWidthDesktop: PropTypes.number,
	maxWidthMobile: PropTypes.number,
	classOverlay: PropTypes.string,
	borderRadius: PropTypes.bool,
	borderRadiusTop: PropTypes.bool,
	borderRadiusBottom: PropTypes.bool
};

// Add this before the export


export default Container;
